import debug from "debug";

import plugin from '../../lib/plugin';
import { mustache } from '../../lib/strings';
import * as dismiss from '../dismiss';

const PLUGIN_NAME = 'paypalButtonContainer';
const MODULE_NAME = 'app.core/modules/paypal-payments';
const log = debug(MODULE_NAME);

const DISMISSABLE_MESSAGE_TEMPLATE = '#dismissable-message-template';

const ELEMENT_SELECTOR = '[data-paypal-button-container]';
const PARENT_ELEMENT_SELECTOR = '[data-payment-option]';
const ERROR_MESSAGE_SELECTOR = '[data-paypal-error-message]';
const LOADING_BUTTON_SELECTOR ='[data-paypal-loading-button]';
const ACCORDION_RADIO_TOGGLE_ELEMENT_SELECTOR = '[data-accordion-radio-toggle]';
const LOADING_HIDDEN_CLASS = 'hide';

const LANDING_PAGE_TYPE_ATTR = 'data-paypal-landing-page-type';
const BUTTON_COLOUR_ATTR = 'data-paypal-button-colour';
const BUTTON_LABEL_ATTR = 'data-paypal-button-label';
const CART_ID_ATTR = 'data-paypal-cart-id';


class PayPalPayments {
	constructor(element, options) {
		this.element = element;
		this.options = options;
		this.$element = $(element);
		this.$parentElement = this.$element.closest(PARENT_ELEMENT_SELECTOR);
		this.$errorMessageElement = this.$parentElement.find(ERROR_MESSAGE_SELECTOR);
		this.$loadingElement = this.$parentElement.find(LOADING_BUTTON_SELECTOR);
		this.dismissableMessageTemplate = $(DISMISSABLE_MESSAGE_TEMPLATE).text();
		this.landingPageType = this.$element.attr(LANDING_PAGE_TYPE_ATTR);
		this.buttonColour = this.$element.attr(BUTTON_COLOUR_ATTR);
		this.buttonLabel = this.$element.attr(BUTTON_LABEL_ATTR);
		this.cartId = this.$element.attr(CART_ID_ATTR);
		this.$accordionRadios = $(ACCORDION_RADIO_TOGGLE_ELEMENT_SELECTOR);
		this.id = '#' + this.$element.attr('id');
		this.toggleLoading(true, false);
		this.loadOrderId();
		log('options', options);
	}

	toggleLoading(isLoading, toggleDisabled) {
		if (isLoading) {
			this.$element.hide();
			this.$loadingElement.removeClass(LOADING_HIDDEN_CLASS);
			if (toggleDisabled) {
				this.$accordionRadios.attr('disabled', 'disabled');
			}
		}
		else {
			this.$element.show();
			this.$loadingElement.addClass(LOADING_HIDDEN_CLASS);
			this.$accordionRadios.removeAttr('disabled');
		}
	}

	setErrorMessage(message) {
		this.toggleLoading(false,false);
		var newItem = mustache(this.dismissableMessageTemplate, {
		 	className: '',
		 	id:'pay-pal-error',
		 	message: message
		});

		this.$errorMessageElement.html(newItem);
		dismiss.exec();
	}

	completeOrder(details) {
		var obj = this;
		const urlCompleteOrder = `${this.options.completeOrderEndpointUrl}?orderId=${details.Order.id}&cartId=${this.cartId}&prefix=${this.options.prefix}`;
		$.ajax({
			url: urlCompleteOrder,
			method: 'post',
			success: function(response) {
				var details = JSON.parse(response);
				if (details.success == true) {
					window.location = details.url;
				}
				else {
					obj.setErrorMessage(details.errorMessage);
					obj.toggleLoading(false, false);
				}
			},
			error: function(args) {
				obj.setErrorMessage('An error occurred whilst completing PayPal order. Please try a different payment option.');
				obj.toggleLoading(false, false);
			}
		});
	}

	approveOrder(details) {
		var obj = this;
		if (details.Success == true) {
  			if (typeof(details.Order.error) !== 'undefined' && details.Order.error === 'INSTRUMENT_DECLINED') {
  				obj.setErrorMessage('PayPal order returned error code: INSTRUMENT_DECLINED. Please try a different payment option.');
  				obj.toggleLoading(false, true);
		        return actions.restart();
		    }
		    else {
		  		obj.completeOrder(details);
	  		}
  		}
  		else {
  			obj.setErrorMessage(details.ErrorMessage);
  			obj.toggleLoading(false, true);
  		}
	}

	createOrder() {
		var obj = this;
		const urlCreateOrder = `${this.options.createOrderEndpointUrl}?landingPage=${this.landingPageType}&cartId=${this.cartId}&prefix=${this.options.prefix}`;
		return new Promise(function(resolve, reject) {
			$.ajax({
				url: urlCreateOrder,
				method: 'post',
				headers: {
					'content-type': 'application/json'
				},
				success: function(res) {
					var data = res;
					if (data.Success == true) {
						var orderId = data.Order.id;
						obj.orderId = orderId;
						resolve(orderId);
					}
				 	else {
				 		var error = typeof(data.ErrorMessage !== 'undefined') ? data.ErrorMessage : 'An error occurred whilst creating PayPal order. Please try a different payment option.';
						obj.setErrorMessage(error);
						reject(error);
					}
				},
				error: function(args) {
					var error='An error occurred whilst creating PayPal order. Please try a different payment option.';
					obj.setErrorMessage(error);
					reject(error);
				}
			});
		});
	}

	loadOrderId() {
		var obj = this;
		let promise = this.createOrder();
		promise.then(
			orderId => obj.renderButtons()
		);
	}

	loadApproveOrder(orderId) {
		var obj = this;
		const urlCaptureOrder = `${this.options.captureOrderEndpointUrl}?orderId=${orderId}&cartId=${this.cartId}&prefix=${this.options.prefix}`;
		return new Promise(function(resolve, reject) {
			$.ajax({
				url: urlCaptureOrder,
				method: 'post',
				headers: {
					'content-type': 'application/json'
				},
				success: function(details) {
					resolve(details);
				},
				error: function(args) {
					var error='An error occurred whilst capturing PayPal order. Please try a different payment option.';
					obj.setErrorMessage(error);
					reject(error);
				}
			});
		});
	}

	loadOrderDetails() {
		let createOrderPromise = obj.createOrder();
		createOrderPromise.then(
			data => obj.renderButtons(data),
			error => obj.setErrorMessage(`${error.message}`)
		);
	}

	validateCartOnClick(data, actions) {
		const endpoint = `${this.options.validateCartEndpoint}?prefix=${this.options.prefix}&paypalOrderId=${this.orderId}`;
		const cartChangedError = this.setErrorMessage.bind(this, 'Your cart has changed. Please refresh this page before trying again.');

		this.toggleLoading(true, true);
		return fetch(endpoint, {
			method: 'POST',
			headers: {
				'Content-Type': 'application/json'
			}
		}).then(function(response) {
			return response.json();
		}).then(function(json) {
			if (json === true) {
				return actions.resolve();
			} else {
				cartChangedError();
				return actions.reject();
			}
		}).finally(this.toggleLoading.bind(this, false, false));
	}



	renderButtons() {
		const obj = this;
		obj.toggleLoading(false, false);
		paypal.Buttons({
			createOrder: function(data, actions) {
				obj.toggleLoading(true, true);
				return obj.orderId;
			},
			onClick: this.validateCartOnClick.bind(this),
			onApprove: function(data) {
			 	let promise = obj.loadApproveOrder(data.orderID);
				promise.then(
					details => obj.approveOrder(details),
					error => obj.setErrorMessage(`Error: ${error.message}`)
				);
			},
			style: {
				layout :'horizontal',
				height: 44,
			 	size: 'large',
				branding:false,
				fundingicons: false,
				tagline: false,
				label : obj.buttonLabel,
				color:obj.buttonColour
			},
		 	onCancel: function(data, actions) {
		 		obj.toggleLoading(false, false);
		 	},
			onError: function (err) {
				obj.setErrorMessage('An error occurred whilst creating PayPal order. Please try a different payment option. ' + err);
			}
		}).render(obj.id);
	}
}

PayPalPayments.DEFAULTS = {
	completeOrderEndpointUrl: $(`meta[name="site.payPalCompleteOrderApiEndpoint"]`).attr('content'),
	createOrderEndpointUrl: $(`meta[name="site.payPalCreateOrderApiEndpoint"]`).attr('content'),
	captureOrderEndpointUrl: $(`meta[name="site.payPalCaptureOrderApiEndpoint"]`).attr('content'),
	prefix : $(`meta[name="site.prefix"]`).attr('content'),
};

plugin(PLUGIN_NAME, PayPalPayments);

export function exec() {
	$(document).ready(() => {
	   $(ELEMENT_SELECTOR)[PLUGIN_NAME]();
	});
}



// WEBPACK FOOTER //
// ./client/src/core/modules/paypal-payments/index.js